module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-links container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.linksdata) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.linksdata.image ? _vm.linksdata.image.path : ''
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.linksdata) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.linksdata.title) + "\n        ")]), _vm._v(" "), (_vm.linksdata.content) ? _c('markdown', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "source": _vm.linksdata.content
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.links), function(link, index) {
    return _c('p', {
      key: ("" + index)
    }, [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(link.title) + " "), _c('i', {
      staticClass: "fa fa-external-link"
    })])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.linksdata) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive is-hidden-mobile",
    attrs: {
      "src": _vm.linksdata.image ? _vm.linksdata.image.path : ''
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184b4702","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Links.vue
// module id = 965
// module chunks = 1